import { Link } from 'react-router-dom';

const legalLinks = [
  { path: '/legal/mentions-legales', label: 'Mentions légales' },
  { path: '/legal/cgu', label: 'CGU' },
  { path: '/legal/cgv', label: 'CGV' },
  { path: '/legal/cookies', label: 'Cookies' },
];

const LandingFooter = () => {
  return (
    <footer className="bg-[#080C1E] border-t border-white/[0.07] px-6 py-10">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo + copyright */}
          <div className="flex items-center gap-4">
            <img
              src="https://storage.readdy-site.link/project_files/88b042fa-1b1e-4828-a084-65a05e6769ac/242fee5f-76d2-4bf5-b968-77fd062724cd_IMG_20260126_015045_031.webp?v=f427f7850abf122c2fe0f72017d39364"
              alt="AD.NOVA.PRO"
              className="h-7 w-auto object-contain opacity-60"
            />
            <span className="text-white/20 text-xs">
              © 2026 AD.NOVA.PRO — MADAME AURELIE PINTO — Micro-entrepreneur
            </span>
          </div>

          {/* Legal links */}
          <div className="flex flex-wrap gap-4 justify-center">
            {legalLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-xs text-white/30 hover:text-[#C9A227] transition-colors cursor-pointer"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
